import React from 'react';

//Material
import { Avatar, Box, Grid, Typography } from '@mui/material';

//Components
import { Stack } from '@mui/system';
// import CardCarousel from '../../../components/CardCarousel';
//images
// import folkFlowers from '../../../assets/folkFlowers.png';
import ornamentDot from '../../../assets/ornamentDot.png';
import firstWing from '../../../assets/wingColor.png';
// import secondWing from '../../../assets/wingImage.png';
import secondWing from '../../../assets/wingImage.webp';

// import DefaultIMG from '../../../assets/DefaultIMG.png';
import vector1 from '../../../assets/Slider/Vector1.png';
import vector2 from '../../../assets/Slider/Vector2.png';
import vector3 from '../../../assets/Slider/Vector3.png';
import vector4 from '../../../assets/Slider/Vector4.png';
import vector5 from '../../../assets/Slider/Vector5.png';
import vector6 from '../../../assets/Slider/Vector6.png';
// import folkFlowers2 from '../../../assets/folkFlowers2.png';
// import { useState } from 'react';
// import { LetsGoBtn, LetsGoBtn2 } from '../../../components/Buttons';
import { LetsGoBtn } from '../../../components/Buttons';
import { useDispatch, useSelector } from 'react-redux';
import { setIsOpenAuthModal } from '../../../redux/mainReducer';
import { StyledTitle } from '../../../components/StyledComponents';
import { useNavigate } from 'react-router-dom';

export default function TopBlock() {
  // const [current, setCurrent] = useState(0);
  // const titles=[
  //   'Створи аккаунт і використай всі можливості сайту'
  // ]
  const userData = useSelector((state) => state.global.userData);
  const language = useSelector((state) => state.Intl.locale);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // useEffect(() => {
  //   const element = document.getElementById('questionsBlock');
  // }, []);
  // useEffect(() => {
  //   if (window.screen.width <= 900) {
  //     setScreenType('mobile');
  //   }
  // }, []);

  const cards = [
    {
      vector: vector1,
      title: 'Підтримуй та плекай українське – воно душу й серце гріє.'
    },
    {
      vector: vector2,
      title: 'Знайом зі своїм продуктом, бо він того вартий.'
    },
    {
      vector: vector3,
      title: 'Створюй зв’язки та прозорі стосунки, адже це основа довіри.'
    },
    {
      vector: vector4,
      title: 'Розвивай свій бізнес та отримуй прибуток.'
    },
    {
      vector: vector5,
      title: 'Отримуй миттєві сповіщення, щоб бути завжди в курсі подій.'
    },
    {
      vector: vector6,
      title: 'Ділись своїми новинами – нам це дійсно цікаво.'
    }
  ];

  return (
    <Grid xs={12} item sx={{ mt: { xs: 10, sm: 15 } }}>
      <Box className="topBlock-main-info">
        <Stack
          sx={{
            marginTop: { xs: 0, sm: 8 },
            marginRight: { xs: 0, sm: 2 },
            width: { xs: 'auto', sm: '100%' }
          }}
        >
          <Typography
            variant="h1"
            sx={{
              fontFamily: 'Kyiv-Sans-Medium !important',
              fontWeight: '400',
              fontSize: { xs: '70px', sm: '112px', md: '112px', lg: '112px' },
              lineHeight: '124px',
              position: 'relative',
              color: 'black',
              display: 'flex'
            }}
          >
            BONFA
            <Typography
              variant="h2"
              sx={{
                fontFamily: 'Kyiv-Sans-Medium !important',
                fontWeight: '400',
                position: 'relative',
                fontSize: { xs: '70px', sm: '112px', md: '112px', lg: '112px' },
                lineHeight: '124px'
              }}
            >
              <Avatar
                sx={{
                  position: 'absolute',

                  right: { xs: 'calc(50% - 20px)' },
                  top: { xs: '5px', sm: '-10px' },
                  '&.MuiAvatar-root .MuiAvatar-img': {
                    objectFit: 'contain !important'
                  }
                }}
                src={ornamentDot}
                alt="ornament"
              />
              I
            </Typography>
            R
          </Typography>
          <Typography
            variant="h2"
            marginLeft={0}
            textTransform="uppercase"
            sx={{
              width: '100%',
              fontSize: { xs: '32px', sm: '40px' },
              lineHeight: '50px',
              mt: 1
            }}
          >
            ЯРМАРОК НОВОГО ПОКОЛІННЯ
          </Typography>
          <Typography
            marginLeft={0}
            sx={{
              mt: 2,
              width: '100%',
              maxWidth: { xs: '100%', sm: '100%', md: '750px !important' },
              fontStyle: 'normal',
              fontSize: '20px',
              fontWeight: '400',
              lineHeight: '29px',
              letterSpacing: '0em',
              textAlign: 'left',
              fontFamily: 'FixelText-Regular'
            }}
          >
            Ми – українська Social Selling платформа, що поєднала торговий майданчик та соціальну
            мережу в одному місці через створення довірчих відносин між виробником і покупцем.
          </Typography>
          <LetsGoBtn
            text="Нумо гляньмо!"
            width={{ xs: '100%', sm: '230px' }}
            margin={{ xs: '30px auto', sm: '30px 0px 0px 0px' }}
            onClick={() => {
              if (userData?.id) {
                navigate(`/${language}/ribbon`);
              } else {
                dispatch(setIsOpenAuthModal(true));
              }
            }}
          />
        </Stack>
        <Stack className="topBlock-main-info-wings">
          <img alt="first-wing" className="topBlock-main-info-firstWing" src={firstWing} />
          <img
            className="topBlock-main-info-secondWing"
            alt="second-wing"
            style={{ position: 'absolute', bottom: '190px' }}
            src={secondWing}
          />
        </Stack>
      </Box>

      <Box className="topBlock-main-carousel-1">
        <StyledTitle
          variant="h2"
          sx={{ lineHeight: '48px !important' }}
          className="bottomBlock-title"
        >
          Отримуй всі переваги від користування Bonfair
        </StyledTitle>
        <Grid
          container
          spacing={2}
          // className="topBlock-main-carousel-wrap"
          // style={{ width: '1440px' }}
        >
          {/*<Slider {...settings}>*/}
          {cards.map((el, index) => {
            return (
              <Grid
                item
                xs={12}
                sm={6}
                lg={4}
                key={index}
                style={{ display: 'flex', flexDirection: 'row' }}
              >
                <div
                  style={{ cursor: 'pointer' }}
                  className="slideStyle-main"
                  // onMouseEnter={() => {
                  //   handleOpenDesc(el.desc, screenType === 'mobile' && index + 1, index);
                  // }}
                  // onMouseLeave={handleCloseDesc}
                >
                  <img
                    style={{
                      minWidth: '60px',
                      width: '150px',
                      height: '150px',
                      marginLeft: '20px',
                      marginRight: '20px'
                    }}
                    src={el.vector}
                    alt="vector"
                  />

                  <Typography
                    component="span"
                    fontSize={20}
                    fontWeight={700}
                    textAlign="center"
                    variant="body1"
                  >
                    {el.title}
                  </Typography>
                </div>
              </Grid>
            );
          })}
          {/*</Slider>*/}
        </Grid>
      </Box>
    </Grid>
  );
}
